import type { Olympiad } from "./types";

export const olympiadAreas = [
  "Astronomia",
  "Arte",
  "Biologia",
  "Ciências",
  "Filosofia",
  "Física",
  "Geografia",
  "Geometria",
  "História",
  "Literatura",
  "Língua Espanhola",
  "Língua Inglesa",
  "Língua Portuguesa",
  "Lógica",
  "Matemática",
  "Química",
  "Tecnologia",
  "Outras",
] as const;

export type OlympiadArea = (typeof olympiadAreas)[number];

const areaByAcronym: Record<string, OlympiadArea> = {
  ARVORE: "Literatura",
  CANGURU: "Matemática",
  GAMEJAM: "Tecnologia",
  MARATONATECH: "Tecnologia",
  NEUROCIENCIASJC: "Ciências",
  NEUROSANJA: "Ciências",
  OBA: "Astronomia",
  OBB: "Biologia",
  OBF: "Física",
  OBG: "Geografia",
  OBGP: "Geografia",
  OBLI: "Língua Inglesa",
  OMP: "Matemática",
  ONANO: "Tecnologia",
  ONC: "Ciências",
  ONHB: "História",
  ONQB: "Química",
};

const normalizeAcronym = (value: string) =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLocaleUpperCase("pt-BR")
    .replace(/[^A-Z0-9]/g, "");

export function resolveOlympiadArea(
  olympiad: Pick<Olympiad, "acronym" | "area">,
): string {
  return areaByAcronym[normalizeAcronym(olympiad.acronym)] ?? olympiad.area;
}
